export const frontmatter = {
  title: "Gauge Voting & Bribes",
  order: 6,
}

## Voting

veSCALE holders will place their votes once a week on the selection of LP pairings they would like emissions to be distributed to. The pool you vote for will receive fees proportional to your voting percentage, and you receive your share of those fees. All trading fees accrue in the epoch following the vote snapshot.

Once your vote has been placed, the same rolling vote will carry until the voter changes their vote.

### Voting Strategies

- Votes ("ve") decay linearly over the 26 weeks of lock.
- Votes carry over and you don't have to revote, but you will earn quite low rewards if you don't vote manually, as the best pools to vote for will vary each epoch!
- To earn maximum bribe & fee rewards from any pool in the epoch, you must max-lock your NFT and re-cast your vote each epoch.
- The earlier you vote in an epoch, the more votes you will have. Voting late in an epoch will subject you to a greater vote decay.
- It's generally recommended to vote on Tuesdays or Wednesdays to wait for the best bribe & fee offerings to show up.
- Our vote optimizers can help you achieve maximum returns

## Bribes

Bribes are in addition to fees and will be claimable 24-48 hours after the snapshot which occurs each Wednesday at 23:59 UTC, the end of each epoch. Any rewards not collected will accrue to future epochs.

## Rewards Explained

There are 3 types of rewards on offer from the Scale.farm protocol:

### Emissions

The emissions are reserved for LP providers and are distributed over each epoch based on veSCALE votes before the start of the new epoch. The rewards will stream over the epoch available for claiming as they accrue.

### Fees

Fees are generated each time a trade is completed on the exchange. These fees are then streamed back to the gauge voters proportionate to their voting share. You can claim these rewards as they accrue for your selected pair/s.

### Bribes

Finally, bribes are an additional opportunity for anyone holding veSCALE. Bribes are potentially allocated to a gauge to incentivize voters to vote for that pair.

The bribes accrue and are only available for claim after the Wednesday 23:59 UTC snapshot is taken. They are proportionate to your voting power cast to the relevant gauge.
